export default __webpack_public_path__ + "static/media/pic2.905c270b.jpg";